/* @flow */

import React from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export const ReplaceModalFooter = (props: { onClick: () => void; onClickI18nKey: string }) => {
    return (
        <div className="replace-dialog-footer">
            <FormattedMessage id="EX_REPLACE_TOGGLE_INFOTEXT" />
            &emsp;
            <Button bsStyle="primary" onClick={props.onClick}>
                <FormattedMessage id={props.onClickI18nKey} />
            </Button>
        </div>
    );
};
